<template>
    <label>
        <div class="image">
            <img v-if="image" v-bind:src="image" />
        </div>
        <input @change="selectImage" type="file" :name="name" />
    </label>
</template>

<script>
import { blobToDataUrl } from "@/helpers/files";

export default {
    props: {
        name: String,
    },
    data() {
        return {
            image: null,
        };
    },
    methods: {
        selectImage(event) {
            const file = event.target.files[0];

            this.$emit("image-change", file);
            blobToDataUrl(file).then((value) => (this.image = value));
        },
    },
};
</script>

<style lang="scss" scoped>
.image {
    width: 70px;
    height: 70px;
    border-radius: 100%;
    position: relative;
    overflow: hidden;
    background: #e6ebed;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        cursor: pointer;
    }

    img {
        width: 100%;
    }
}

input {
    display: none;
}
</style>
